import React from 'react';
import menuContext, { MenuContext } from './menuContext';

const useMenu = (): MenuContext => {
  const context = React.useContext<MenuContext>(menuContext);
  return context;
};

export default useMenu;
